// extracted by mini-css-extract-plugin
export default {"tableTotal":"TableToolbar_tableTotal__km+ta"};